import React, { Component } from 'react';
import PropTypes from 'prop-types';

function isSizeEqual(a, b) {
  return a.width === b.width && a.height === b.height;
}

/**
 * @param {Array} array1
 * @param {Array} array2
 * @returns {boolean}
 */
function isArrayOfSizesEqual(array1, array2) {
  if (array1.length !== array2.length) {
    return false;
  }
  return array1.every(function (size1, i) {
    return isSizeEqual(size1, array2[i]);
  });
}

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css = ".styles_root__3WDXs {\n  display: flex;\n}\n\n.styles_colsHeader__45znm {\n  display: inline-flex;\n  flex-wrap: nowrap;\n  text-align: center;\n}\n\n.styles_colsHeaderItem__zbWXk {\n  box-sizing: border-box;\n}\n\n.styles_rowsHeader__1FWyl {\n  box-sizing: border-box;\n}\n\n.styles_rowsHeaderItem__ci3Vz {\n  box-sizing: border-box;\n}\n\n.styles_rowsBody__fE1ix {\n  position: relative;\n  width: 100%;\n  overflow-x: scroll;\n  overflow-y: hidden;\n  /*todo: need customization*/\n  padding-bottom: 30px;\n}\n\n.styles_gridLine__3ydGq {\n  position: absolute;\n  background: #CCCCCC;\n}\n\n.styles_row__2gmnz {\n  position: relative;\n  overflow: hidden;\n}\n\n.styles_element__H99Gj {\n  position: absolute;\n  overflow: hidden;\n  box-sizing: border-box;\n  padding: 0.5rem 0;\n}\n\n.styles_element__H99Gj:hover {\n  z-index: 1; /*todo: animate*/\n}\n";
var styles = { "root": "styles_root__3WDXs", "colsHeader": "styles_colsHeader__45znm", "colsHeaderItem": "styles_colsHeaderItem__zbWXk", "rowsHeader": "styles_rowsHeader__1FWyl", "rowsHeaderItem": "styles_rowsHeaderItem__ci3Vz", "rowsBody": "styles_rowsBody__fE1ix", "gridLine": "styles_gridLine__3ydGq", "row": "styles_row__2gmnz", "element": "styles_element__H99Gj" };
styleInject(css);

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var toConsumableArray = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  } else {
    return Array.from(arr);
  }
};

// todo: functional + hooks

var Timeline = function (_Component) {
  inherits(Timeline, _Component);

  function Timeline(props) {
    classCallCheck(this, Timeline);

    var _this = possibleConstructorReturn(this, (Timeline.__proto__ || Object.getPrototypeOf(Timeline)).call(this, props));

    _initialiseProps.call(_this);

    var _this$props = _this.props,
        cols = _this$props.cols,
        rows = _this$props.rows;


    _this.colsHeaderRef = React.createRef();
    _this.rowsRefs = rows.map(React.createRef);
    _this.elementsRefs = rows.reduce(function (acc, row, rowIndex) {
      acc[rowIndex] = row.elements.map(React.createRef);
      return acc;
    }, {});
    _this.currentTimeLabelRef = React.createRef();
    _this.rowsBodyRef = React.createRef();

    var from = new Date(Math.min.apply(Math, toConsumableArray(rows.map(function (row) {
      return Math.min.apply(Math, toConsumableArray(row.elements.map(function (el) {
        return el.start;
      })));
    }))));
    var to = new Date(Math.max.apply(Math, toConsumableArray(rows.map(function (row) {
      return Math.max.apply(Math, toConsumableArray(row.elements.map(function (el) {
        return el.end;
      })));
    }))));
    var duration = Math.floor(to.getTime() / 1000) - Math.floor(from.getTime() / 1000);

    _this.state = {
      from: from,
      to: to,
      colsHeaderSize: undefined,
      currentTimeLabelSize: undefined,
      horizontalOffset: undefined,
      rowSizes: undefined,
      colWidth: undefined,
      // rows summary height
      summaryRowsHeight: undefined,
      colsCount: cols.length,
      rowsCount: rows.length,
      duration: duration,
      verticalGridLineElevation: 5,
      scrollSize: undefined
    };
    return _this;
  }

  createClass(Timeline, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      window.addEventListener('resize', this.handleResize);
      window.requestAnimationFrame(function () {
        _this2.handleLayoutChange();

        if (_this2.props.scrollToCurrentTime) {
          _this2.scrollToCurrentTime();
        }

        _this2.rowsBodyRef.current.addEventListener('scroll', _this2.handleScroll);
      });
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.handleResize);
      this.rowsBodyRef.current.removeEventListener('scroll', this.handleScroll);
    }

    // todo: allow customize

  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          rows = _props.rows,
          rowsBodyClass = _props.rowsBodyClass,
          rowClass = _props.rowClass,
          elementClass = _props.elementClass,
          maxWidth = _props.maxWidth,
          current = _props.current,
          renderElement = _props.renderElement,
          alignElementHeight = _props.alignElementHeight;
      var _state = this.state,
          colsHeaderSize = _state.colsHeaderSize,
          rowSizes = _state.rowSizes,
          colWidth = _state.colWidth,
          summaryRowsHeight = _state.summaryRowsHeight;


      var style = {
        maxWidth: maxWidth ? maxWidth + 'px' : null
      };

      var rowsBodyClasses = [styles.rowsBody, rowsBodyClass];

      return React.createElement(
        'div',
        {
          className: styles.root,
          style: style
        },
        colsHeaderSize && rowSizes && this.renderRowsHeader(),
        React.createElement(
          'div',
          {
            ref: this.rowsBodyRef,
            className: rowsBodyClasses.join(' ')
          },
          colWidth && summaryRowsHeight && this.renderGrid(),
          colWidth && summaryRowsHeight && current && this.renderCurrentTimeLine(),
          this.renderColsHeader(),
          colsHeaderSize && rows.map(function (row, rowIndex) {
            var rowStyle = {};

            if (rowSizes) {
              rowStyle.width = rowSizes[rowIndex].width + 'px';
              rowStyle.height = rowSizes[rowIndex].height + 'px';
            }

            return React.createElement(
              'div',
              {
                key: row.key,
                ref: _this3.rowsRefs[rowIndex],
                className: [styles.row, rowClass].join(' '),
                style: rowStyle
              },
              row.elements.map(function (element, elementIndex) {
                var x1 = _this3.timeToOffset(element.start);
                var x2 = _this3.timeToOffset(element.end);

                var elementStyle = { left: x1 + 'px', width: x2 - x1 + 'px' };

                if (alignElementHeight && rowStyle.height) {
                  elementStyle.height = rowStyle.height;
                }

                return React.createElement(
                  'div',
                  {
                    key: element.key,
                    ref: _this3.elementsRefs[rowIndex][elementIndex],
                    onClick: _this3.handleElementClick(element, rowIndex),
                    className: [styles.element, elementClass].join(' '),
                    style: elementStyle
                  },
                  renderElement(element)
                );
              })
            );
          })
        )
      );
    }
  }]);
  return Timeline;
}(Component);

var _initialiseProps = function _initialiseProps() {
  var _this4 = this;

  this.calculateSize = function (ref) {
    return {
      width: ref.current.offsetWidth,
      height: ref.current.offsetHeight
    };
  };

  this.calculateRowSize = function (rowIndex) {
    // we find max value of width and height because children are absolute positioned
    var width = Math.max.apply(Math, toConsumableArray(_this4.elementsRefs[rowIndex].map(function (ref) {
      return ref.current.offsetWidth + ref.current.offsetLeft;
    })));
    var height = Math.max.apply(Math, toConsumableArray(_this4.elementsRefs[rowIndex].map(function (ref) {
      return ref.current.offsetHeight;
    })));

    return {
      width: width, // this.rowsRefs[rowIndex].current.offsetWidth,
      height: height // this.rowsRefs[rowIndex].current.offsetHeight
    };
  };

  this.handleLayoutChange = function () {
    var _props2 = _this4.props,
        fixedColWidth = _props2.fixedColWidth,
        current = _props2.current,
        useMaxRowHeight = _props2.useMaxRowHeight;
    var _state2 = _this4.state,
        colsHeaderSize = _state2.colsHeaderSize,
        currentTimeLabelSize = _state2.currentTimeLabelSize,
        scrollSize = _state2.scrollSize,
        rowSizes = _state2.rowSizes,
        colsCount = _state2.colsCount;


    var nextColHeaderSize = _this4.calculateSize(_this4.colsHeaderRef);

    // получили значение ширины
    if (colsHeaderSize === undefined || !isSizeEqual(nextColHeaderSize, colsHeaderSize)) {
      // we use fixed width or calculate it base on current cols header width
      var colWidth = fixedColWidth === undefined ? Math.round(nextColHeaderSize.width / colsCount) : fixedColWidth;

      // // we need even number for division to 2
      // if (colWidth % 2 !== 0) {
      //   colWidth += 1
      // }

      var horizontalOffset = Math.floor(colWidth / 2);

      _this4.setState({
        colsHeaderSize: nextColHeaderSize,
        horizontalOffset: horizontalOffset,
        colWidth: colWidth
      });
    }

    var nextRowsSize = _this4.props.rows.map(function (_, i) {
      return _this4.calculateRowSize(i);
    });
    if (rowSizes === undefined || !isArrayOfSizesEqual(rowSizes, nextRowsSize)) {
      if (useMaxRowHeight) {
        var maxHeight = Math.max.apply(Math, toConsumableArray(nextRowsSize.map(function (v) {
          return v.height;
        })));
        nextRowsSize = nextRowsSize.map(function (v) {
          return _extends({}, v, {
            height: maxHeight
          });
        });
      }

      _this4.setState({
        rowSizes: nextRowsSize,
        summaryRowsHeight: nextRowsSize.reduce(function (acc, v) {
          return acc + v.height;
        }, 0)
      });
    }

    var rowsBodySize = _this4.calculateSize(_this4.rowsBodyRef);
    if (rowsBodySize !== undefined && rowsBodySize.width !== scrollSize) {
      _this4.setState({
        scrollSize: _this4.rowsBodyRef.current.scrollWidth - rowsBodySize.width
      });
    }

    if (current) {
      var nextCurrentTimeLabelSize = _this4.calculateSize(_this4.currentTimeLabelRef);
      if (currentTimeLabelSize === undefined || !isSizeEqual(nextCurrentTimeLabelSize, currentTimeLabelSize)) {
        _this4.setState({
          currentTimeLabelSize: nextCurrentTimeLabelSize
        });
      }
    }
  };

  this.handleResize = function () {
    return _this4.handleLayoutChange();
  };

  this.handleScroll = function () {
    var _state3 = _this4.state,
        scrollSize = _state3.scrollSize,
        colWidth = _state3.colWidth;

    var pos = _this4.rowsBodyRef.current.scrollLeft;

    /* this.setState({ scrollX: scrollPosition }) */

    if (!_this4.props.handleScroll) {
      return;
    }

    var event = 'scrolled';
    if (Math.abs(pos - 0) < colWidth) {
      event = 'scroll-begin';
    } else if (Math.abs(pos - scrollSize) < colWidth) {
      event = 'scroll-end';
    }

    _this4.props.handleScroll(pos, event);
  };

  this.handleElementClick = function (element, rowIndex) {
    return function (e) {
      if (!_this4.props.handleElementClick) {
        return;
      }
      _this4.props.handleElementClick(element, rowIndex, e);
    };
  };

  this.scrollToCurrentTime = function () {
    _this4.currentTimeLabelRef.current.scrollIntoView({
      inline: 'center'
    });
  };

  this.timeToOffset = function (date) {
    var _state4 = _this4.state,
        from = _state4.from,
        colsHeaderSize = _state4.colsHeaderSize,
        duration = _state4.duration,
        horizontalOffset = _state4.horizontalOffset;

    var offset = Math.floor(date.getTime() / 1000) - Math.floor(from.getTime() / 1000);

    return Math.floor(colsHeaderSize.width * offset / duration) + horizontalOffset;
  };

  this.renderRowsHeader = function () {
    var _props3 = _this4.props,
        rows = _props3.rows,
        rowsHeaderClass = _props3.rowsHeaderClass,
        renderRowHeaderItem = _props3.renderRowHeaderItem;
    var _state5 = _this4.state,
        colsHeaderSize = _state5.colsHeaderSize,
        rowSizes = _state5.rowSizes;


    return React.createElement(
      'div',
      {
        className: [styles.rowsHeader, rowsHeaderClass].join(' '),
        style: { paddingTop: colsHeaderSize.height + 'px' }
      },
      rows.map(function (row, rowIndex) {
        var style = {
          height: rowSizes[rowIndex].height + 'px'
        };

        return React.createElement(
          'div',
          {
            key: row.key,
            className: [styles.rowsHeaderItem, 'item'].join(' '),
            style: style
          },
          renderRowHeaderItem(row)
        );
      })
    );
  };

  this.renderColsHeader = function () {
    var _props4 = _this4.props,
        cols = _props4.cols,
        colsHeaderClass = _props4.colsHeaderClass,
        renderColHeaderItem = _props4.renderColHeaderItem;
    var colWidth = _this4.state.colWidth;

    var colStyle = {
      width: colWidth ? colWidth + 'px' : null
    };

    return React.createElement(
      'div',
      {
        ref: _this4.colsHeaderRef,
        className: [styles.colsHeader, colsHeaderClass].join(' ')
      },
      cols.map(function (col) {
        return React.createElement(
          'div',
          {
            key: col.key,
            className: [styles.colsHeaderItem, 'item'].join(' '),
            style: colStyle
          },
          renderColHeaderItem(col)
        );
      })
    );
  };

  this.renderHorizontalLine = function (x, y, width, color) {
    return React.createElement('div', {
      key: 'h_' + x + '-' + y,
      className: [styles.gridLine, _this4.props.gridLineClass].join(' '),
      style: {
        background: color,
        width: width + 'px',
        height: '1px',
        left: x + 'px',
        top: y + 'px'
      }
    });
  };

  this.renderVerticalLine = function (x, y, height, color) {
    return React.createElement('div', {
      key: 'v_' + x + '-' + y,
      className: [styles.gridLine, _this4.props.gridLineClass].join(' '),
      style: {
        background: color,
        width: '1px',
        height: height + 'px',
        left: x + 'px',
        top: y + 'px'
      }
    });
  };

  this.renderGrid = function () {
    var _props5 = _this4.props,
        horizontalGridLineVisible = _props5.horizontalGridLineVisible,
        verticalGridLineVisible = _props5.verticalGridLineVisible;
    var _state6 = _this4.state,
        colsHeaderSize = _state6.colsHeaderSize,
        colsCount = _state6.colsCount,
        colWidth = _state6.colWidth,
        rowSizes = _state6.rowSizes,
        summaryRowsHeight = _state6.summaryRowsHeight,
        horizontalOffset = _state6.horizontalOffset,
        verticalGridLineElevation = _state6.verticalGridLineElevation;


    var res = [];

    if (horizontalGridLineVisible) {
      var y = 0;
      y += colsHeaderSize.height;

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = rowSizes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var rowSize = _step.value;

          res.push(_this4.renderHorizontalLine(0, y, colsHeaderSize.width + horizontalOffset));
          y += rowSize.height;
        }

        // last line
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      res.push(_this4.renderHorizontalLine(0, y, colsHeaderSize.width + horizontalOffset));
    }

    if (verticalGridLineVisible) {
      var x = horizontalOffset;

      for (var j = 0; j < colsCount; j++) {
        res.push(_this4.renderVerticalLine(x, colsHeaderSize.height - verticalGridLineElevation, summaryRowsHeight + verticalGridLineElevation));
        x += colWidth;
      }

      // last line
      res.push(_this4.renderVerticalLine(x, colsHeaderSize.height - verticalGridLineElevation, summaryRowsHeight + verticalGridLineElevation));
    }

    return res;
  };

  this.renderCurrentTimeLine = function () {
    var _props6 = _this4.props,
        current = _props6.current,
        currentTimeOverlapClass = _props6.currentTimeOverlapClass,
        renderCurrentTimeLabel = _props6.renderCurrentTimeLabel;
    var _state7 = _this4.state,
        summaryRowsHeight = _state7.summaryRowsHeight,
        colsHeaderSize = _state7.colsHeaderSize,
        verticalGridLineElevation = _state7.verticalGridLineElevation;

    var x = _this4.timeToOffset(current);

    return React.createElement(
      'div',
      {
        key: x,
        style: {
          position: 'absolute',
          top: colsHeaderSize.height + 'px',
          left: 0,
          width: x + 'px'
        },
        className: currentTimeOverlapClass
      },
      React.createElement('div', {
        style: {
          height: summaryRowsHeight + 'px'
        },
        className: 'overlap'
      }),
      React.createElement(
        'div',
        {
          ref: _this4.currentTimeLabelRef,
          style: {
            position: 'absolute',
            bottom: -verticalGridLineElevation + 'px',
            right: 0,
            transform: 'translate(50%, 100%)'
          },
          className: 'label'
        },
        renderCurrentTimeLabel(current)
      )
    );
  };
};

Timeline.propTypes = {
  current: PropTypes.instanceOf(Date),
  rows: PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.string.isRequired,
    elements: PropTypes.arrayOf(PropTypes.shape({
      key: PropTypes.string.isRequired,
      start: PropTypes.instanceOf(Date).isRequired,
      end: PropTypes.instanceOf(Date).isRequired
    })).isRequired
  })).isRequired,
  cols: PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.string.isRequired,
    start: PropTypes.instanceOf(Date).isRequired,
    end: PropTypes.instanceOf(Date).isRequired
  })).isRequired,
  maxWidth: PropTypes.number,
  fixedColWidth: PropTypes.number,
  renderElement: PropTypes.func.isRequired,
  renderColHeaderItem: PropTypes.func.isRequired,
  renderRowHeaderItem: PropTypes.func.isRequired,
  renderCurrentTimeLabel: PropTypes.func,
  handleElementClick: PropTypes.func,
  handleScroll: PropTypes.func,
  scrollToCurrentTime: PropTypes.bool,
  useMaxRowHeight: PropTypes.bool,
  // todo: validate with requiredIf or make yours validator
  currentTimeOverlapClass: PropTypes.string,
  rowsHeaderClass: PropTypes.string,
  colsHeaderClass: PropTypes.string,
  elementClass: PropTypes.string,
  gridLineClass: PropTypes.string,
  rowsBodyClass: PropTypes.string,
  rowClass: PropTypes.string,
  verticalGridLineVisible: PropTypes.bool,
  horizontalGridLineVisible: PropTypes.bool,
  alignElementHeight: PropTypes.bool
};

Timeline.defaultProps = {
  verticalGridLineVisible: true,
  horizontalGridLineVisible: true,
  alignElementHeight: false,
  useMaxRowHeight: false
};

export default Timeline;
//# sourceMappingURL=index.es.js.map



//////////////////
// WEBPACK FOOTER
// ../dist/index.es.js
// module id = 20
// module chunks = 0